import CopyLinkWrapper from "components/shared/CopyLinkWrapper";
import RowingJules from "components/svgs/jules/RowingJules";
import Container from "hardcover-ui/components/Container";
import Icon from "hardcover-ui/components/Icon";
import Text from "hardcover-ui/components/Text";
import TextLink from "hardcover-ui/components/TextLink";
import faAndroid from "icons/brands/android.svg";
import faApple from "icons/brands/app-store-ios.svg";
import faDiscord from "icons/brands/discord.svg";
import faInstagram from "icons/brands/instagram.svg";
import faMastodon from "icons/brands/mastodon.svg";
import faTiktok from "icons/brands/tiktok.svg";
import info from "icons/solid/circle-info.svg";
import link from "icons/solid/link.svg";

interface LinkType {
  name: string;
  href: string;
  target: string;
  local?: boolean;
  icon?: any;
  props?: any;
}

const navigation = {
  social: [
    {
      name: "iOS",
      href: "https://apps.apple.com/us/app/hardcover-app/id1663379893",
      icon: faApple,
    },
    {
      name: "Android",
      href: "https://play.google.com/store/apps/details?id=hardcover.app",
      icon: faAndroid,
    },
    {
      name: "Discord",
      href: "https://discord.gg/hardcover",
      icon: faDiscord,
    },
    {
      name: "TikTok",
      href: "https://www.tiktok.com/@hardcoverapp",
      icon: faTiktok,
    },
    {
      name: "Mastodon",
      href: "https://mastodon.hardcover.app/@hardcover",
      icon: faMastodon,
    },
    {
      name: "Instagram",
      href: "https://instagram.com/hardcover.app",
      icon: faInstagram,
    },
  ] as LinkType[],
};

export default function DesktopFooter() {
  return (
    <Container
      variant="layout"
      size="lg"
      className="hidden lg:block mt-8 pt-8  overflow-hidden h-full border-t border-b border-gray-100 dark:border-gray-700/50 "
    >
      <h2 id="footer-heading" className="sr-only">
        Footer links
      </h2>
      <div className="flex flex-row w-full gap-4 justify-between px-4 xl:px-0">
        <div className="flex flex-col gap-2">
          <Text as="p" variant="secondary" size="sm">
            Community
          </Text>
          <TextLink href="/readers" underline={false}>
            Readers & Supporters
          </TextLink>
          <div className="flex items-center gap-2">
            <TextLink
              href="https://discord.gg/hardcover"
              underline={false}
              external
              target="_blank"
            >
              Join Our Discord
            </TextLink>
            <TextLink
              href="https://hardcover.app/pages/how-to-link-hardcover-roles-with-discord"
              underline={false}
              aria-label="How to link Hardcover roles with Discord"
              data-tooltip-id="tooltip"
              data-tooltip-content="How to link Hardcover roles with Discord"
            >
              <Icon icon={info} size="md" className="text-gray-400" />
              <span className="sr-only">How to link roles on Discord</span>
            </TextLink>
          </div>
          <CopyLinkWrapper>
            <button
              aria-label="Copy referral link"
              className="flex gap-1 items-center hover:underline"
            >
              Copy referral link{" "}
              <Icon icon={link} size="lg" className="text-gray-400" />
            </button>
          </CopyLinkWrapper>
        </div>

        <div className="flex flex-col gap-2">
          <div className="flex flex-col gap-2">
            <Text as="p" variant="secondary" size="sm">
              Follow Along
            </Text>
            <TextLink href="/blog" underline={false}>
              Blog
            </TextLink>
            <TextLink href="/live" underline={false}>
              Hardcover Live
            </TextLink>
            <TextLink href="/pages/about" underline={false}>
              About Hardcover
            </TextLink>
            <TextLink
              href="https://roadmap.hardcover.app/"
              underline={false}
              external
              target="_blank"
            >
              Request a feature
            </TextLink>
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <Text as="p" variant="secondary" size="sm">
            We're an Open Book
          </Text>
          <TextLink href="/pages/faq" underline={false}>
            Frequently Asked Questions
          </TextLink>
          <TextLink href="/pages/support" underline={false}>
            Contact Support
          </TextLink>
          <TextLink
            href="https://roadmap.hardcover.app/"
            underline={false}
            external
            target="_blank"
          >
            Roadmap
          </TextLink>
          <TextLink href="/pages/policies" underline={false}>
            Our Policies
          </TextLink>
        </div>

        <div className="flex flex-col gap-16 justify-between items-end h-full">
          <div className="flex space-x-6 ">
            {navigation.social.map(item => (
              <TextLink
                key={item.name}
                href={item.href}
                variant="secondary"
                external
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="sr-only">{item.name}</span>
                <Icon
                  icon={item.icon}
                  size="lg"
                  className="dark:fill-gray-300 dark:hover:fill-gray-50 hover:fill-gray-600 transition-all"
                />
              </TextLink>
            ))}
          </div>
          <RowingJules className=" w-52 -mb-4" />
        </div>
      </div>
    </Container>
  );
}
